import { render, staticRenderFns } from "./MyClasses.vue?vue&type=template&id=44b0db8e"
import script from "./MyClasses.vue?vue&type=script&lang=js"
export * from "./MyClasses.vue?vue&type=script&lang=js"
import style0 from "./MyClasses.vue?vue&type=style&index=0&id=44b0db8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports